module.exports = __webpack_public_path__ + "give_mobile.png";